import type {ReactElement} from 'react';
import {Button, Size, Type} from '@Components/button';
import {Text, TextSize} from '@Components/text';
import type {DesignSelectionSummaryBarProps} from './design-selection-summary-bar.types';
import styles from './design-selection-summary-bar.module.scss';

export function DesignSelectionSummaryBar({selectedDesignCount, onDeselectAll}: DesignSelectionSummaryBarProps): ReactElement | null {
  if (selectedDesignCount === 0) {
    return null;
  }

  const deselectCtaText = selectedDesignCount === 1 ? window.i18next.t('pmwjs_deselect') : window.i18next.t('pmwjs_deselect_all');

  return (
    <div className={styles.selectionSummaryBar}>
      <Text size={TextSize.MD} bold val={window.i18next.t('pmwjs_x_designs_selected', {count: selectedDesignCount})} className={styles.selectionSummaryBarCount} />
      <Button type={Type.DARK_SECONDARY} size={Size.SMALL} text={deselectCtaText} onClick={onDeselectAll} />
    </div>
  );
}
